export default __webpack_public_path__ + "static/media/flag-republic-of-macedonia.33aeb18d.svg";